import TransactionEndpoint from "@/core/services/api/endpoints/admin/TransactionEndpoint";
import UserEndpoint from "@/core/services/api/endpoints/admin/UserEndpoint";
import ActivityLogEndpoint from "@/core/services/api/endpoints/admin/ActivityLogEndpoint";
import AuthCheckpointsEndpoint from "@/core/services/api/endpoints/admin/AuthCheckpointsEndpoint";
import CompanyEndpoint from "@/core/services/api/endpoints/admin/CompanyEndpoint";
import BankAccountEndpoint from "@/core/services/api/endpoints/admin/BankAccountEndpoint";
import SystemEndpoint from "@/core/services/api/endpoints/admin/SystemEndpoint";
import AnnouncementEndpoint from "@/core/services/api/endpoints/admin/AnnouncementEndpoint";
import KycFileArchiveEndpoint from "@/core/services/api/endpoints/admin/KycFileArchiveEndpoint";
import SettingsEndpoint from "@/core/services/api/endpoints/admin/SettingsEndpoint";
import TimelineEndpoint from "@/core/services/api/endpoints/admin/TimelineEndpoint";

class AdminEndpoints {
  transaction = new TransactionEndpoint();
  timeline = new TimelineEndpoint();
  user = new UserEndpoint();
  system = new SystemEndpoint();
  company = new CompanyEndpoint();
  settings = new SettingsEndpoint();
  activity_log = new ActivityLogEndpoint();
  auth_checkpoint = new AuthCheckpointsEndpoint();
  bank_account = new BankAccountEndpoint();
  announcement = new AnnouncementEndpoint();
  kyc_file_archive = new KycFileArchiveEndpoint();
}

export default AdminEndpoints;
